// extracted by css-extract-rspack-plugin
export default {"cls1":"PostPrompt-cls1_nSR","cls2":"PostPrompt-cls2_RnD PostPrompt-cls1_nSR"};